import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import {
    toggle_single_dynamic_field_activated,
    set_params_to_current_url_for_dynamic_field_activated,
    load_all_dynamic_field_activated,
    remove_all_dynamic_field_activated
} from "src/store/slice/model/BOM/BOMFieldActivated";

import { useBOMStore } from "../../../hooks/bom";
import BOM from "@system/config/bom";
import System from "../../../helper/system";

const bomId = System.getParams().bomId

const BomEditColumnsPopup = (props) => {
    const { SetStatus } = props
    const dispatch = useDispatch(false);
    const [{ bom_detail_by_bom_id, exact_dynamic_field_activated, bom_detail_by_bom_id_type }, { get_bom_detail_by_bom_id }] = useBOMStore();

    useEffect(() => {
        async function fetchHere() {
            if (bom_detail_by_bom_id?.bomId) {
                await get_bom_detail_by_bom_id({ bomId: bom_detail_by_bom_id.bomId })
            }
        }
        fetchHere()
    }, [])

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const setStatusOfForFieldActivated = (singleBomColumnMapping) => {
        dispatch(toggle_single_dynamic_field_activated({
            ...bom_detail_by_bom_id,
            ...singleBomColumnMapping
        }))
    };

    const setAllStatusOfForFieldActivated = () => {
        if (bom_detail_by_bom_id_type.bomColumnMapping && Object.entries(bom_detail_by_bom_id_type.bomColumnMapping).length > 0) {
            dispatch(load_all_dynamic_field_activated({
                ...bom_detail_by_bom_id,
                bomColumnMapping: bom_detail_by_bom_id_type.bomColumnMapping
            }))
        }
    };
    const getStatusOfForFieldActivated = (singleBomColumnMapping) => {
        if (exact_dynamic_field_activated &&
            exact_dynamic_field_activated[bom_detail_by_bom_id.bomId] &&
            exact_dynamic_field_activated[bom_detail_by_bom_id.bomId][singleBomColumnMapping.columnName]
        ) {
            return exact_dynamic_field_activated[bom_detail_by_bom_id.bomId][singleBomColumnMapping.columnName];
        }
        return false
    };

    return (
        <>
            <div className="avnet-modal modal-630">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            onHide()
                        }}>×
                    </button>
                    <div className="modal-header text-center">
                        <h3 className="pcn-modal-heading">Edit Columns</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="light-card m-b-15">
                            <div className="light-card-header">
                                <div className="light-card-title">
                                    Check the columns from your upload that you'd wish to add to BOM
                                </div>
                            </div>
                            <div className="light-card-body pb-0">
                                <div className="mb-3">
                                    <a className='text-blue2 me-1' href={void (0)} onClick={() => {
                                        setAllStatusOfForFieldActivated()
                                    }}>Select All</a>
                                    |
                                    <a className='text-blue2 ms-1' href={void (0)} onClick={() => {
                                        dispatch(remove_all_dynamic_field_activated(bom_detail_by_bom_id))
                                    }}>Clear All</a>
                                </div>
                                <ul className="three-col pl-0 m-b-10">
                                    {bom_detail_by_bom_id_type.bomColumnMapping && Object.entries(bom_detail_by_bom_id_type.bomColumnMapping).length > 0 &&
                                        Object.entries(bom_detail_by_bom_id_type.bomColumnMapping).map((v) => (
                                            <li key={v[1].columnName}>
                                                <div className="form-check m-b-10">
                                                    <input type="checkbox" className="form-check-input font-13"
                                                        checked={getStatusOfForFieldActivated(v[1])}
                                                        onChange={(e) => {
                                                            setStatusOfForFieldActivated(v[1])
                                                        }}
                                                        id={'checkBox' + v[1].columnName}
                                                        name={'checkBox' + v[1].columnName} />
                                                    <label className="form-check-label mt-0 font-13 "
                                                        htmlFor={'checkBox' + v[1].columnName}>{v[1].fileColumnName}
                                                    </label>
                                                </div>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                        {bom_detail_by_bom_id !== undefined && bom_detail_by_bom_id.isRematched !== undefined && bom_detail_by_bom_id.isRematched === false &&
                            <a className="text-blue2 mt-3" href={BOM.getBomRematchRouteURL({ bomId })}>Re-match
                                columns</a>
                        }
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary minw-auto w100"
                                data-toggle="modal"
                                data-target="#DownloadBOM"
                                onClick={() => {
                                    onHide()
                                }}>
                                CLOSE
                            </button>
                            <button type="button" className="bs5 btn btn-primary minw-auto w130" data-toggle="modal"
                                onClick={() => {
                                    dispatch(set_params_to_current_url_for_dynamic_field_activated())
                                    onHide()
                                }}
                            >
                                Save Columns
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BomEditColumnsPopup;